import { getActiveAbTestConfig, getPatternByPercentage } from '../config/abTest/abTestConfig'

interface UseAbTestProps {
    abValue: number
    currentPath?: string
}

export const useAbTest = ({ 
    abValue, 
    currentPath = typeof window !== 'undefined' ? window.location.pathname + window.location.search : '/'
}: UseAbTestProps): 'A' | 'B' | 'C' | 'D' => {
    const activeConfig = getActiveAbTestConfig(currentPath)
    
    if (!activeConfig) {
        return 'A'
    }
    
    return getPatternByPercentage(abValue, activeConfig.patterns)
}
